
export default class GHPath {
  constructor (arg) {
    this.indices = [];
    if (arg instanceof GHPath) {
      this.indices = this.indices.concat(arg.indices.map(i => i));
    } else if (arg instanceof Array) {
      this.indices = this.indices.concat(arg.map(i => i));
    } else if (typeof arg === 'string') {
      arg = arg.replace('{', '');
      arg = arg.replace('}', '');
      let args = arg.split(';');
      args.forEach(val => this.indices.push(parseInt(val, 10)));
    } else {
      switch (typeof arg) {
        case 'number':
          this.indices.push(arg);
          break;
        default:
          this.indices.push(0);
          break;
      }
    }
  }

  add (index) {
    if (index instanceof GHPath) {
      index = index.clone();
      this.indices = this.indices.concat(index.indices);
    } else if (index instanceof Array) {
      this.indices = this.indices.concat(index.map(i => i));
    } else {
      switch (typeof index) {
        case 'number':
          this.indices.push(index);
          break;
        default:
          console.log('non valid path add', index);
          break;
      }
    }
  }

  clone () {
    return new GHPath(this);
  }

  toString () {
    return this.indices.join(';');
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHPath.js